export default [
  // 百万阅读选书页面
  {
    path: '/million/read/select',
    name: 'MillionReadSelect',
  },
  // 百万阅读书城页面
  {
    path: '/million/read/list',
    name: 'MillionReadList',
  },
  // 百万阅读书架页面
  {
    path: '/million/read/favorite',
    name: 'MillionReadFavorite',
  },
  // 百万阅读使用指南页面
  {
    path: '/million/read/user/guide',
    name: 'MillionReadUserGuide',
  },
  // 百万阅读会员购买页面
  {
    path: '/million/read/vip/:id(\\d+)',
    name: 'MillionReadVipDetail',
  },
  // 百万阅读会员预售页面
  {
    path: '/million/read/vip/pre/sale/:id(\\d+)',
    name: 'MillionReadVipPreSaleDetail',
  },
  // 百万阅读会员预售详情页面
  {
    path: '/million/read/vip/pre/sale/detail/:id(\\d+)',
    name: 'MillionReadVipPreSaleDetailed',
  },
  // 百万阅读会员权益页面
  {
    path: '/million/read/vip/rights',
    name: 'MillionReadVipRights',
  },
  // 百万阅读会员服务协议页面
  {
    path: '/million/read/vip/term',
    name: 'MillionReadVipTerm',
  },
  // 百万阅读必填信息页面
  {
    path: '/million/read/required/info',
    name: 'MillionReadRequiredInfo',
  },
  // 百万阅读读书页面
  {
    path: '/million/read/learn',
    name: 'MillionReadLearnDetail',
  },
  // 百万阅读书籍详情页面
  {
    path: '/million/read/interpret',
    name: 'MillionReadInterpretBook',
  },
  // 百万阅读书籍详情如何学习页面
  {
    path: '/million/read/interpret/learn/guide',
    name: 'MillionReadInterpretLearnGuide',
  },
  // 百万阅读答题页面
  {
    path: '/million/read/question',
    name: 'MillionReadQuestion',
  },
  // 百万阅读答题解析页面
  {
    path: '/million/read/question/analysis',
    name: 'MillionReadQuestionAnalysis',
  },
  // 百万阅读奖励页面
  {
    path: '/million/read/reward',
    name: 'MillionReadReward',
  },
  // 百万阅读个人中心页面
  {
    path: '/million/read/my',
    name: 'MillionReadMine',
  },
  // 百万阅读勋章列表页面
  {
    path: '/million/read/medal',
    name: 'MillionReadMedal',
  },
  // 百万阅读升级版勋章详情页面
  {
    path: '/million/read/upgrade/medal/:id(\\d+)',
    name: 'MillionReadUpgradeMedalDetail',
  },
  // 百万阅读升级版勋章详情页面
  {
    path: '/million/read/collect/medal/:id(\\d+)',
    name: 'MillionReadCollectionMedalDetail',
  },
  // 百万阅读勋章分享页面
  {
    path: '/million/read/medal/share/:id(\\d+)',
    name: 'MillionReadMedalShare',
  },
  // 百万阅读证书列表页面
  {
    path: '/million/read/certificate',
    name: 'MillionReadCertificate',
  },
  // 百万阅读证书分享页面
  {
    path: '/million/read/certificate/share',
    name: 'MillionReadCertificateShare',
  },
  // 百万阅读报告详情页面
  {
    path: '/million/read/report',
    name: 'MillionReadReportDetail',
  },
  // 百万阅读报告分享页面
  {
    path: '/million/read/report/share',
    name: 'MillionReadReportShare',
  },
  // 百万阅读大作业页面
  {
    path: '/million/read/mission',
    name: 'MillionReadMission',
  },
  // 百万阅读 App端评论页
  {
    path: '/million/read/app/comment',
    name: 'MillionReadAppComment',
  },
  // 百万阅读 App端音频详情页
  {
    path: '/million/read/app/audio',
    name: 'MillionReadAppAudio',
  },
  // 百万阅读 App端节目详情页
  {
    path: '/million/read/app/program',
    name: 'MillionReadAppProgram',
  },
  // 百万阅读 App端大作业页
  {
    path: '/million/read/app/mission',
    name: 'MillionReadAppMission',
  },
  // 百万阅读 App端作品详情页
  {
    path: '/million/read/app/work/detail',
    name: 'MillionReadAppWorkDetail',
  },
  // 百万阅读 App端作品编辑
  {
    path: '/million/read/app/work/edit',
    name: 'MillionReadAppWorkEdit',
  },
  // 百万阅读 资讯详情页面
  {
    path: '/million/read/article/:id(\\d+)',
    name: 'MillionReadArticleDetail',
  },
  // 百万阅读 书单页面
  {
    path: '/million/read/book/list',
    name: 'MillionReadBookList',
  },
  // 百万阅读 作品集列表页
  {
    path: '/million/read/recommend/work',
    name: 'MillionReadRecommendWork',
  },
  // 转介绍 邀请说明页
  {
    path: '/million/read/invite',
    name: 'MillionReadInvite',
  },
  // 转介绍 邀请说明页
  {
    path: '/million/read/invite/rule',
    name: 'MillionReadInviteRule',
  },
  // 领取百万阅读体验会员详情页
  {
    path: '/million/read/experience/vip',
    name: 'MillionReadExperienceVip',
  },
  // 百万阅读周榜
  {
    path: '/million/read/weekly/report/:id(\\d+)',
    name: 'MillionReadWeeklyReport',
  },
  // 百万阅读完整榜单
  {
    path: '/million/read/ranking/study',
    name: 'MillionReadRankingStudy',
  },
  // 百万阅读书籍列表
  {
    path: '/million/read/list/explore',
    name: 'MillionReadListExplore',
  },
  // 百万阅读书单列表
  {
    path: '/million/read/book/list/explore',
    name: 'MillionReadBookListExplore',
  },
  // 百万阅读书单详情
  {
    path: '/million/read/book/list/detail/:id(\\d+)',
    name: 'MillionReadBookListDetail',
  },
  // 百万阅读最近加入同学列表
  {
    path: '/million/read/interpret/:id(\\d+)/member',
    name: 'MillionReadJoinedMember',
  },
  // 百万阅读用户中心
  {
    path: '/million/read/user/center',
    name: 'MillionReadUserCenter',
  },
  // 百万阅读用户书架
  {
    path: '/million/read/user/favorite',
    name: 'MillionReadUserCenterFavorite',
  },
  // 百万阅读用户勋章
  {
    path: '/million/read/user/medal',
    name: 'MillionReadUserCenterMedal',
  },
  // 百万阅读用户勋章
  {
    path: '/million/read/user/certificate',
    name: 'MillionReadUserCenterCertificate',
  },
  // 百万阅读用户作品
  {
    path: '/million/read/user/work',
    name: 'MillionReadUserCenterWork',
  },
  {
    // 兑换课程
    path: '/exchange',
    name: 'ExchangeDetail',
  },
  {
    // 公司批量兑换课程
    path: '/exchange/topic',
    name: 'ExchangeTopicDetail',
  },
  {
    // 公司批量兑换课程通知页
    path: '/exchange/topic/notify',
    name: 'ExchangeTopicNotify',
  },
  {
    // 积分中心
    path: '/point/center',
    name: 'PointCenter',
  },
  {
    // 积分明细
    path: '/point/detail',
    name: 'MyPointDetail',
  },
  {
    // 积分好友助力
    path: '/point/share/:targetType(\\w+)/:targetId(\\d+)',
    name: 'PointShareProduct',
  },
  {
    // 积分好友邀请记录
    path: '/point/invite/record',
    name: 'PointInviteRecord',
  },
  {
    // 积分帮助
    path: '/point/help',
    name: 'PointHelp',
  },
  {
    // 积分商品列表页
    path: '/point/product/list',
    name: 'PointProductList',
  },
  {
    // 积分兑换详情页
    path: '/point/product/detail',
    name: 'PointProductDetail',
  },
  {
    // 积分 解锁积分海报页
    path: '/point/share/invite',
    name: 'PointShareInvite',
  },
  {
    // 积分 新人礼包活动页
    path: '/point/invite/member',
    name: 'PointInviteMember',
  },
  {
    // 积分 新人礼包兑换成功通知页
    path: '/point/invite/member/notify',
    name: 'PointInviteMemberNotify',
  },
  {
    // 积分 新人礼包兑换成功通知页
    path: '/point/new/member/gift',
    name: 'PointNewMemberGift',
  },
  // 兑换商城主页
  {
    path: '/exchange/mall',
    name: 'ExchangeMallHome',
  },
  // 我的熊熊币页面
  {
    path: '/exchange/mall/coin',
    name: 'ExchangeMallCoinDetail',
  },
  // 我的熊熊币 赚取攻略页面
  {
    path: '/exchange/mall/coin/raiders',
    name: 'ExchangeMallCoinRaiders',
  },
  // 我的熊熊币 赚取攻略完整规则页面
  {
    path: '/exchange/mall/coin/raiders/rule',
    name: 'ExchangeMallCoinRaidersRule',
  },
  // 兑换商品详情页
  {
    path: '/exchange/mall/shop/:id(\\d+)',
    name: 'ExchangeMallShopDetail',
  },
  // 兑换商品记录
  {
    path: '/exchange/mall/record',
    name: 'ExchangeMallRecord',
  },
  // 父母学院 发现页
  {
    path: '/parents/college',
    name: 'ParentsCollegeIndex',
  },
  // 父母学院 读书会页面
  {
    path: '/parents/college/live',
    name: 'ParentsCollegeLive',
  },
  // 父母学院 读书会详情页面
  {
    path: '/parents/college/live/:id(\\d+)',
    name: 'ParentsCollegeLiveDetail',
  },
  // 父母学院 课程页面
  {
    path: '/parents/college/course',
    name: 'ParentsCollegeCourse',
  },
  // 父母学院 个人中心页面
  {
    path: '/parents/college/my',
    name: 'ParentsCollegeMine',
  },
  // 父母学院 分类列表页面
  {
    path: '/parents/college/category',
    name: 'ParentsCollegeCategory',
  },
  // 父母学院 分类详情页面
  {
    path: '/parents/college/category/:id(\\d+)',
    name: 'ParentsCollegeCategoryDetail',
  },
  // 父母学院 搜索页面
  {
    path: '/parents/college/search',
    name: 'ParentsCollegeSearch',
  },
  // 父母学院 视频详情页面
  {
    path: '/parents/college/video/:id(\\d+)',
    name: 'ParentsCollegeVideoDetail',
  },
  // 父母学院 关于我们页面
  {
    path: '/parents/college/aboutus',
    name: 'ParentsCollegeAboutUs',
  },
  // 父母学院 历史记录列表页面
  {
    path: '/parents/college/history',
    name: 'ParentsCollegeHistory',
  },
  // 表达力测评首页
  {
    path: '/express/evaluation',
    name: 'ExpressEvaluation',
  },
  // 表达力测评选择年级页面
  {
    path: '/express/evaluation/grade',
    name: 'ExpressEvaluationGrade',
  },
  // 表达力测评测试页面
  {
    path: '/express/evaluation/test',
    name: 'ExpressEvaluationTest',
  },
  // 表达力测评报告页面
  {
    path: '/express/evaluation/report',
    name: 'ExpressEvaluationReport',
  },
];
